<div class="font-bold flex items-center p-2 {{coloredRow ? coloredRowColor : ''}}"
     [ngClass]="{'grid grid-cols-2 gap-y-2 gap-x-4': inline, 'bg-opacity-40': coloredRow}">
  <div class="{{titleSize}} {{primaryTextColor}} flex items-center">
    {{label}}
    <psc-info-icon [iconColorClass]="primaryTextColor" [infoText]="infoText"></psc-info-icon>
  </div>
  <div [ngClass]="{'grid grid-cols-2 gap-x-4 items-center': secondValue !== undefined}">
    <div class="{{primaryTextColor}} text-xl text-right">
      {{ (value !== undefined && value !== null) ? (value | number:digitsInfo) : '' }}
      {{ (stringValue !== undefined && stringValue !== null) ? stringValue : '' }}
      {{ (value === undefined || value === null) && (stringValue === undefined || stringValue === null) ? '-' : '' }} {{ unit }}
    </div>
    <div *ngIf="secondValue !== undefined" class="{{secondaryTextColor}} text-xl text-right">
      {{ +secondValue ? (secondValue | number:digitsInfo) : secondValue }} {{ unit }}
    </div>
  </div>
</div>
